// extracted by mini-css-extract-plugin
module.exports = {"root":"Title-module--root--t2Uzx","slider":"Title-module--slider--2sqZQ"};